// Context attached to a recruiter question, derived from the current route.
// v_admin has no path params: ids live in $route.query.

export const CONTEXT_ID_KEYS = ['applicant_id', 'position_id', 'offer_id']

export const CHIP_LABELS = {
  applicant_id: 'מועמד',
  position_id: 'משרה',
  offer_id: 'הצעה'
}

const toPositiveInt = value => {
  if (value === undefined || value === null || value === '') return null
  const raw = Array.isArray(value) ? value[0] : value
  if (!/^\d+$/.test(String(raw).trim())) return null
  const n = parseInt(raw, 10)
  return n > 0 ? n : null
}

/** Build { route_name, applicant_id?, position_id?, offer_id? } from a vue-router route. */
export const buildContextFromRoute = route => {
  const query = (route && route.query) || {}
  const ctx = { route_name: (route && route.name) ? String(route.name) : '' }
  CONTEXT_ID_KEYS.forEach(key => {
    const id = toPositiveInt(query[key])
    if (id) ctx[key] = id
  })
  return ctx
}

export const contextIdKeys = ctx => CONTEXT_ID_KEYS.filter(key => ctx && ctx[key])

export const hasContextIds = ctx => contextIdKeys(ctx).length > 0

/** Returns a new context without the given id key (chip removal). */
export const removeContextKey = (ctx, key) => {
  const next = { ...(ctx || {}) }
  delete next[key]
  return next
}

/**
 * Freeze semantics: chips follow the route until the recruiter starts typing.
 * Once the draft has any non-whitespace text the context is frozen and route
 * changes no longer touch it (only "השתמשי בעמוד הנוכחי" refreshes it).
 */
export const isContextFrozen = draft => typeof draft === 'string' && draft.trim().length > 0

export const nextContextOnRouteChange = ({ current, draft, route }) =>
  isContextFrozen(draft) ? current : buildContextFromRoute(route)

/** Chip label from /context response names, falling back to "#id". */
export const chipLabel = (key, ctx, names) => {
  const id = ctx[key]
  const n = names || {}
  let name = null
  if (key === 'applicant_id' && n.applicant && n.applicant.id == id) name = n.applicant.name
  if (key === 'position_id' && n.position && n.position.id == id) {
    name = n.position.name
    if (name && n.position.company_name) name = name + ' · ' + n.position.company_name
  }
  if (key === 'offer_id' && n.offer && n.offer.id == id) name = '#' + id
  return CHIP_LABELS[key] + ': ' + (name || '#' + id)
}

export const OWNER_NAME_MAX = 80

/** Trimmed owner display name (left-menu select box), capped; '' when absent. */
export const normalizeOwnerName = name =>
  typeof name === 'string' ? name.trim().substr(0, OWNER_NAME_MAX).trim() : ''

/**
 * Payload for POST: route_name + ids (server resolves names), plus owner_name —
 * the recruiter name selected in the left menu, so the agent addresses her by
 * it. owner_name is never a chip (contextIdKeys only covers ids).
 */
export const contextPayload = (ctx, ownerName) => {
  const out = { route_name: (ctx && ctx.route_name) || '' }
  contextIdKeys(ctx).forEach(key => { out[key] = ctx[key] })
  const owner = normalizeOwnerName(ownerName)
  if (owner) out.owner_name = owner
  return out
}
